import * as types from "./types";

const initialState = {
  packages: [],
  selectedPackage: {},
  consultationOrder: {},
  consultationRequests: [],
  consultationRequest: {},
};

const consultationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PACKAGES:
      return {
        ...state,
        packages: action.payload,
      };
    case types.SET_SELECTED_PACKAGE:
      return {
        ...state,
        selectedPackage: action.payload,
      };
    case types.SET_CONSULTATION_ORDER:
      return {
        ...state,
        consultationOrder: action.payload,
      };
    case types.SET_CONSULTATION_REQUESTS:
      return {
        ...state,
        consultationRequests: action.payload,
      };
    case types.SET_CONSULTATION_REQUEST:
      return {
        ...state,
        consultationRequest: action.payload,
      };
    default:
      return state;
  }
};

export default consultationReducer;
